import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const PromoBlockTitle = props => {
  const { className, children, ...other } = props;

  return (
    <h2 className={clsx("em-c-promo-block__title", className)} {...other}>
      {children}
    </h2>
  );
};

PromoBlockTitle.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

PromoBlockTitle.defaultProps = {
  className: "",
  children: null
};

export default PromoBlockTitle;
